import React from "react";
import { AppstoreOutlined, BarChartOutlined, BookOutlined, CustomerServiceOutlined, DashboardOutlined, DollarCircleTwoTone, DollarOutlined, SafetyCertificateFilled, ShopFilled, TeamOutlined } from "@ant-design/icons";
import "Common/hooks/StyleFeatures/global.scss"
import { BookSharp, Business, Chat, LibraryAdd, MapSharp } from "@mui/icons-material";
import CORIQPROLandingPage from "PlatForms/Dashboards/CORIQPROAdminDashboard/dashboard/CORIQPROLandinPage"
import CoursesList from "../Courses/CourseList";
import CategoriesList from "../Categories/CategoriesList";
import AuthorsList from "../Authors/AuthorsList";
import AdminPaymentLedgerPage from "../PaymentLedger/PaymentLedgers";
import ReportsPage from "../Reports/Reports";
import ExpertServices from "../Expert/ExpertServices";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/proAdmin-dashboard",
    icon: <DashboardOutlined />,
    component: <CORIQPROLandingPage />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Courses",
    key: "courses",
    route: "/proAdmin-dashboard/courses",
    icon: <BookOutlined />,
    component: <CoursesList />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Courses Categories",
    key: "courses-categories",
    route: "/proAdmin-dashboard/categories",
    icon: <AppstoreOutlined />,
    component: <CategoriesList />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Authors List",
    key: "authors-list",
    route: "/proAdmin-dashboard/authors",
    icon: <TeamOutlined />,
    component: <AuthorsList />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Payment Ledgers List",
    key: "payment-ledgers",
    route: "/proAdmin-dashboard/payment-ledgers",
    icon: <DollarOutlined/>,
    component: <AdminPaymentLedgerPage />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Reports",
    key: "reports",
    route: "/proAdmin-dashboard/reports",
    icon: <BarChartOutlined />,
    component: <ReportsPage />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Expert Services",
    key: "expert-services",
    route: "/proAdmin-dashboard/expert-services",
    icon: <CustomerServiceOutlined />,
    component: <ExpertServices />,
    noCollapse: true,
  },
];

export default routes;